import { useEffect } from 'react';
export default function checkForWindowGlobal(globalName) {
  useEffect(function () {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (window[globalName] === undefined) {
        console.error("'".concat(globalName, "' not found, you may need to include a polyfill in your app."));
      }
    }
  }, []);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/checkForWindowGlobal/index.js
// module id = 2005
// module chunks = 12